// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Up-z","breadcrumbForward":"Vp-z","breadcrumbBack":"Wp-z","selected":"Xp-z"};